import * as yup from 'yup';

export interface IStepProfile {
    phone: string;
    email: string;
}

export const stepProfileInitialValues: IStepProfile = {
    phone: '',
    email: ''
}

export const stepProfileSchema = yup.object().shape({
    phone: yup.string()
        .min(7, 'tooShort')
        .max(15, 'tooLong')
        .matches(/^\+?[0-9]*$/, 'wrongFormat')
        .required('required'),
    email: yup.string().required('required').email('wrongFormat')
});
